const dropdown = {
  defaultDropdownValue: 'Select option',
  featureDropdownValue: 'Select options',
};

export default dropdown;



// WEBPACK FOOTER //
// ./src/components/common/vx-dropdown-primary/vx-dropdown-primary-i18n.js